const OVERLAY_PORTAL_ID = 'overlay-root'

export function getOverlayPortalHost() {
  if (typeof document === 'undefined') return null
  return document.getElementById(OVERLAY_PORTAL_ID) ?? document.body
}
